import { render, staticRenderFns } from "./OrgItem.vue?vue&type=template&id=57ab3a4c&scoped=true&"
import script from "./OrgItem.vue?vue&type=script&lang=js&"
export * from "./OrgItem.vue?vue&type=script&lang=js&"
import style0 from "./OrgItem.vue?vue&type=style&index=0&id=57ab3a4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ab3a4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/nantong-hrpark-prod-mobile-company(微信公众号-企业）/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('57ab3a4c', component.options)
    } else {
      api.reload('57ab3a4c', component.options)
    }
    module.hot.accept("./OrgItem.vue?vue&type=template&id=57ab3a4c&scoped=true&", function () {
      api.rerender('57ab3a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/admin/comps/OrgItem.vue"
export default component.exports